import { connect } from 'react-redux';
import DuplicateModal from './DuplicateModal';
import { duplicateSection } from '../../redux/section/section_actions';

const mapStateToProps = state => ({
  isDuplicating: state.section.isDuplicating,
  errorMessage: state.section.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateSection(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/duplicate/SectionDuplicateModal.js